import React from "react";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import {
  Button,
  DialogActions,
  DialogContent,
  Tooltip
} from "@material-ui/core";
import { PaperComponent } from "../../../utils/helper";
import { IoMdCloseCircleOutline } from "react-icons/io";

/**
 * Dialog Modal component to show popup with Child component as prop
 */
class DialogModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: this.props.open || false
    };
  }

  /** Onload function with latest values */
  componentWillReceiveProps(newProps) {
    const { open } = this.state;
    if (newProps.open != open) {
      this.setState({
        open: true
      });
    }
  }

  render() {
    const { fullWidth = true, maxWidth = "md", className } = this.props;
    return (
      <Dialog
        fullWidth={fullWidth}
        open={this.props.open}
        maxWidth={maxWidth}
        PaperComponent={PaperComponent}
        className={className}
      >
        <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
          <Toolbar>
            <Typography variant={"h6"} style={{ marginLeft: "10px", flex: "1" }}>
              {this.props.title}
            </Typography>
            <Tooltip title={"Close"}>
              <IconButton
                title={"Close"}
                edge={"end"}
                color={"inherit"}
                onClick={this.props.onClose}
                aria-label={"close"}
                className={"white-button"}
              >
                <IoMdCloseCircleOutline />
              </IconButton>
            </Tooltip>
          </Toolbar>
        </AppBar>
        <DialogContent>{this.props.children}</DialogContent>
        <DialogActions style={{ paddingRight: "24px" }}>
          <Button
            autoFocus
            color={"primary"}
            onClick={() => {
              this.props.onClose();
            }}
          >
            {"Close\r"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default DialogModal;
